import { useState } from "react";
import FocusLock from "react-focus-lock";
import { Controller, useForm } from "react-hook-form";
import { Button, Icon, TextInput } from "@/shared/ui";

type Password = {
  password: string;
  passwordRepeat: string;
};

type Props = {
  onSubmit: (data: Password) => void;
  error?: string;
  pending: boolean;
};

export default function PlayerMenuSettingsSafetyChangePasswordNew({
  onSubmit,
  error = "",
  pending,
}: Props) {
  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm<Password>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      password: "",
      passwordRepeat: "",
    },
  });
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  return (
    <FocusLock className="contents">
      <form
        noValidate
        onSubmit={handleSubmit((data) => {
          if (!errors.password && !errors.passwordRepeat) {
            onSubmit(data);
          }
        })}
        className="gap-3 grow flex flex-col outline-none h-full"
      >
        <Controller
          name="password"
          control={control}
          rules={{
            required: "Пароль не указан",
            minLength: {
              value: 6,
              message: "Минимальная длина пароля 6 символов",
            },
            maxLength: {
              value: 32,
              message: "Максимальная длина пароля 32 символа",
            },
          }}
          render={({ field }) => (
            <TextInput
              {...field}
              type="password"
              placeholder="Придумайте пароль"
              title="Пароль:"
              icon={<Icon name="lock" className="w-4" />}
              required
              inputClassName="text-center"
              invalid={errors.password?.message || ""}
              passwordVisible={isPasswordVisible}
              onChangePasswordVisible={setIsPasswordVisible}
            />
          )}
        />

        <Controller
          name="passwordRepeat"
          control={control}
          rules={{
            required: "Повторите пароль",
            validate: (value) => value === watch("password") || "Пароли не совпадают",
          }}
          render={({ field }) => (
            <TextInput
              {...field}
              type="password"
              placeholder="Повторите новый пароль"
              title="Повторите новый пароль:"
              hiddenTitle
              icon={<Icon name="lock" className="w-4" />}
              required
              inputClassName="text-center"
              invalid={errors.passwordRepeat?.message || ""}
              passwordVisible={isPasswordVisible}
              onChangePasswordVisible={setIsPasswordVisible}
            />
          )}
        />

        <div className="mt-auto grid gap-2.5">
          {!!error && <div className="alert alert--danger">*{error}</div>}
          <Button submit className="btn--md w-full" loading={pending}>
            Сменить пароль
          </Button>
        </div>
      </form>
    </FocusLock>
  );
}
